import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  Button, StaticButton, duration,
} from './follow-button/profile-follow-button-style';
import { scrollIfHashMatch } from './navigation/utils';
import useProtectedClickHandler from './redirect-if-not-signed-in';

const AnimatedFollowButton = React.forwardRef(({
  initialStatus, onUnfollow, buttonName,
  followAction, unfollowAction, collectStats, broadcast,
}, ref) => {
  const [followed, setFollowed] = React.useState(initialStatus);
  const [playing, setPlaying] = React.useState(false);
  const [apiState, setApiState] = React.useState('start');

  React.useImperativeHandle(ref, () => ({ notify: setFollowed }));

  const onClick = useProtectedClickHandler(() => {
    if (!followed) {
      setPlaying(true);
      followAction()
        .then(() => {
          collectStats && collectStats(!followed);
          setApiState('success');
        })
        .catch(() => setApiState('fail'));
    } else {
      setApiState('start');
      setFollowed(false);
      unfollowAction().then(() => {
        collectStats && collectStats(!followed);
        broadcast(!followed);
        onUnfollow && onUnfollow();
      });
    }
  });

  React.useEffect(() => {
    buttonName && scrollIfHashMatch(buttonName, 0);
  }, [buttonName]);

  React.useEffect(() => {
    playing && setTimeout(() => {
      if (apiState === 'success') {
        setPlaying(false);
        broadcast(!followed);
      }
    }, duration);
  }, [playing, apiState, followed, broadcast]);

  if (followed) {
    return (
      <StaticButton
        name={buttonName}
        type="button"
        className="btn btn-primary"
        onClick={onClick}
      >
        <div className="icon-box">
          <span className="icon-full-size icon-lw-user-check" />
        </div>
        <div className="text-box">
          <span className="followed">Following</span>
        </div>
      </StaticButton>
    );
  }

  return (
    <Button
      name={buttonName}
      type="button"
      className={classNames('btn btn-primary', { playing })}
      onClick={onClick}
    >
      <div className="icon-box">
        <span className="icon-full-size icon-lw-plus" />
        <i className="icon-full-size fa fa-check" />
        <span className="icon-full-size icon-lw-user-check" />
      </div>
      <div className="text-box">
        <span className="followed">Following</span>
        <span className="not-followed">Follow</span>
      </div>
    </Button>
  );
});

AnimatedFollowButton.displayName = 'AnimatedFollowButton';

AnimatedFollowButton.propTypes = {
  initialStatus: PropTypes.bool.isRequired,
  buttonName: PropTypes.string.isRequired,
  onUnfollow: PropTypes.func,
  // async () => {}
  followAction: PropTypes.func.isRequired,
  // async () => {}
  unfollowAction: PropTypes.func.isRequired,
  // followStatus => {}
  collectStats: PropTypes.func,
  // followStatus => {}
  broadcast: PropTypes.func.isRequired,
};

AnimatedFollowButton.defaultProps = {
  collectStats: null,
  onUnfollow: null,
};

export default AnimatedFollowButton;
